/**
 *  Create a copy of the given array, sorted by the given property
 */
export function sortArrayByProps<T, K extends keyof T>(arr: T[], prop: K, order: T[K][]) {
  return [...arr].sort((a, b) => order.indexOf(a[prop]) - order.indexOf(b[prop]))
}
